<template>
  <div :style="divStyle">
    <div
      class="v-input v-input--dense v-input--hide-details v-text-field v-text-field--outlined v-text-field--enclosed"
      style="height: 100%;"
    >
      <div class="v-input__control" style="height: 100%;">
        <div class="v-input__slot" style="padding-left: 0; padding-right: 0; height: 100%;">
          <fieldset style="border-radius: 4px; border-color: rgba(1, 0, 0, 0.45);"
                    aria-hidden="true">
            <legend style="font-size: smaller;">Storage files</legend>
          </fieldset>
          <div style="width: 100%; height: 100%; overflow-y: scroll; padding-top: 8px;">
            <v-treeview
              ref="tvStorage"
              dense open-on-click outlined
              :active="file_list_active"
              @update:active="tvStorage_update_active"
              :items="storage_tree" item-key="path"
              :multiple-active="false" :activatable="true"
              style="height: 100%;">
              <template #prepend="{item, selected, open}">
                <v-icon>
                  {{ item.icon_name(selected, open) }}
                </v-icon>
              </template>

              <template #label="{item, open}">
                <v-tooltip right disabled>
                  <template #activator="{ on }">
            <span v-on="on">
              {{ item.name }}
            </span>
                  </template>
                  <template #default>
                    <pre>{{ JSON.stringify(item, null, 2) }}</pre>
                  </template>
                </v-tooltip>
              </template>

            </v-treeview>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

	import format from 'string-format'

	import {mapActions, mapGetters} from "vuex"

	import {File, Folder} from '../../models'

	import {
		mdiFolder, mdiFolderOpen
	} from '@mdi/js'

	export default {
		name: "storage-file-selector",
		data: function () {
			return {
				file_list_active: [],

				storage_tree: [],
			}
		},

		props: {
			// ключ - название файла
			value: {type: String, default: null,},

			// storage_id
			storage: {type: Number, default: -1,},

			width: {type: String, default: null,},
			height: {type: String, default: null,},
			minWidth: {type: String, default: null,},
			minHeight: {type: String, default: null,},
			maxWidth: {type: String, default: null,},
			maxHeight: {type: String, default: null,},
		},

		watch: {

			storage: function () {
				this.update_storage_treeview()
			},

			selected_file_list: function (new_value) {
				console.debug("StorageFileSelectorComponent.watch.file_list_active()")
			},

			value: function (new_value) {
				console.debug(format(
					"StorageFileSelectorComponent.watch.value( '{0}' )",
					this.value))
				this.file_list_active = this.value !== null ? [this.value] : []
			},
		},

		computed: {
			...mapGetters({
				storages: 'storage/storages',
			}),

			divStyle: function () {
				const res = {
					width: this.width,
					height: this.height,
					minWidth: this.minWidth,
					minHeight: this.minHeight,
					maxWidth: this.maxWidth,
					maxHeight: this.maxHeight,
				}

				return res
			}
		},

		mounted: function () {
			this.load_data()
				.then(() => {
					let k = 11
				})

			console.debug(format(
				"StorageFileSelectorComponent.mounted()\n" +
				"  {0}",
				JSON.stringify({
					'storage': this.storage,
					'value': this.value,
				})))

			// this.inputs.storage =
		},

		methods: {
			...mapActions({
				'storage_load_tree': 'storage/load_tree',

				'message_add': 'message/add',

				'progress_begin': 'progress/begin',
				'progress_end': 'progress/end',
			}),

			is_file: function (item) {
				return item instanceof File
			},

			is_folder: function (item) {
				return item instanceof Folder
			},

			load_data: function () {
				this.progress_begin({message: "Loading selected_storage files..."})
				return this.$store.dispatch('storage/list_storage')
					.then(() => {
						return this.update_storage_treeview()
					})
					.catch((error) => this.message_add(error))
					.finally(() => this.progress_end())
			},

			update_storage_treeview: function (force) {
				const storage = this.storages[this.storage]
				if (storage) {
					if (!storage.tree_loaded || force) {
						const me = this
						me.progress_begin({
							message: format("Loading storage '{0}' tree ...", storage.name)
						})
						this.$store.dispatch('storage/load_tree', {storage})
							.then(function (result) {
								me.storage_tree = storage.tree.children
							})
							.catch(function (error) {
								me.message_add(error)
							})
							.finally(function () {
								me.progress_end()
							})
					} else {
						this.storage_tree = storage.tree.children
					}
				} else {
					this.storage_tree = []
				}
			},

			// -- Handle controls' events --

			tvStorage_update_active: function (active_list) {
				console.debug(format(
					"StorageFileSelectorComponent.tvStorage_update_active( [{0}] )",
					active_list.map(a => format("'{0}'", a)).join(', ')))

				const value = active_list.length === 1 ? active_list[0] : null
				this.$emit('input', value)
			},
		},
	}
</script>

<style scoped>

</style>